import Mustache from 'lib/mustache';
import '../application';

$(document).ready(() => {
  // Search button click event.
  $('#searchIcon').click(function () {
    $(this).closest('form').submit();
  });

  // Search sort by select on change event.
  $('.search-container select').change(function () {
    $(this).closest('form').submit();
  });

  // Sort direction click event.
  $('.search-container .icon-down, .search-container > .icon-up').click(function () {
    const $this = $(this);
    const $el = $this.closest('form').find('input[name=order]');
    $el.val($el.val() === 'normal' ? 'reverse' : 'normal');
    $this.closest('form').submit();
  });

  // Show more results link click event.
  $('.more-results > a').click(function () {
    $(this).hide();
    $('#search-result-list').find('li.hidden').removeClass('hidden');
    return false;
  });

  init();
});

const init = () => {
  // Update sort direction icon.
  if ($('.search-container > form').find('input[name=order]').val() === 'reverse') {
    $('.search-container .icon-down, .search-container > .icon-up').removeClass('icon-down').addClass('icon-up');
  }

  // Update sort by selection.
  const sortBy = (new URL(document.location)).searchParams.get('sort-by');
  if (sortBy) {
    $('.search-container select').find('option').each(function () {
      const $this = $(this);
      if ($this.val() === sortBy) {
        $this.attr('selected', 'selected');
      } else {
        $this.removeAttr('selected');
      }
    });
  }

  search();
};

const search = () => {
  const params = (new URL(document.location)).searchParams;
  $.ajax({
    type: 'post',
    url: '/ajax/alleventssearch',
    dataType: 'json',
    data: {
      searchText: params.get('search-term'),
      sortBy: params.get('sort-by') || $('.search-container select').val(),
      dir: params.get('order') || $('.search-container > form').find('input[name=order]').val()
    },
    success: (data) => {
      if (data.length) {
        const template = $('#search_results_template').html();
        let html = '';
        for (const i in data) {
          data[i].index = parseInt(i) + 1;
          data[i].hidden = i > 9 ? 'hidden' : '';
          data[i].total_donations = data[i].total_donations ? data[i].total_donations.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00';
          data[i].photo = `<img ${data[i].index > 3 ? 'class="lazyload" data-src' : 'fetchpriority="high" src'}="/photo/event/${data[i].event_id}/${data[i].event_year}/medium" alt=""/>`;
          data[i].private_indicator = data[i].private ? '' : 'hide-private-event-indicator';
          html += Mustache.render(template, data[i]);
        }
        $('.search-error').hide();
        $('.search-result-none').hide();
        $('#search-result-list').html(html).show();
        privateEventToolTipButtonsAssignEventHandlers();
      } else {
        $('#search-result-list').hide();
        $('.search-error').hide();
        $('.search-result-none').show();
      }
      // If result item count <= 10 then hide the view more results link element.
      $('.more-results > a').toggle(data.length > 10);
    },
    error: (_jqXHR) => {
      $('#search-result-list').hide();
      $('.more-results > a').hide();
      $('.search-result-none').hide();
      $('.search-error').show();
    }
  });
};

const privateEventToolTipButtonsAssignEventHandlers = () => {
  $('.private-event-tooltip-button').each(function () {
    privateEventTooltipButtonAssignEventHandlers($(this));
  });
};

const privateEventTooltipButtonAssignEventHandlers = ($button) => {
  // Button - mouse enter event.
  $button.unbind('mouseenter').bind('mouseenter', function () {
    const $this = $(this);
    const $popup = $('.private-event-tooltip-popup');
    if ($popup.length) {
      const buttonOffset = $this.offset();
      const buttonHeight = $this.height();
      const popupWidth = $popup.width();
      const popupHeight = $popup.height();
      const popupPadding = parseInt($popup.css('padding'));
      $popup.css({
        display: 'block',
        top: buttonOffset.top - popupHeight - (popupPadding * 2) - buttonHeight,
        left: buttonOffset.left - parseInt(popupWidth / 2)
      });
    }
  });
  // Button - mouse leave event.
  $button.unbind('mouseleave').bind('mouseleave', function () {
    $('.private-event-tooltip-popup').css('display', 'none');
  });
};
